module.exports = __webpack_public_path__ + "img/pin_transport_green.a17546a2.svg";